import styled from 'styled-components';
import { ChangeEventHandler, FocusEventHandler, ReactNode } from 'react';
import typographyGenerator from 'typography/generator';
import StyledTextArea from 'components/StyledTextArea';

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const Label = styled.div`
    ${(props => typographyGenerator('label', props.theme))}
    color: ${(props => props.theme?.colors.LM_N60)};
    margin-bottom: 4px;
`;

interface IFormInput {
    label: string,
    name: string | undefined,
    placeholder?: string,
    error?: string,
    errorIcon?: ReactNode | undefined,
    description?: string,
    handleChange: ChangeEventHandler<any> | undefined,
    handleBlur: FocusEventHandler<any> | undefined,
    value: string | ReadonlyArray<string> | number | undefined;
    minHeight?: number;
    minWidth?: number;
}

const FormInput: React.FC<IFormInput> = ({ label, name, placeholder, handleChange, handleBlur, value, description, error, errorIcon, minHeight, minWidth }) => {
    return (
        <Container>
            <Label>{label}</Label>
            <StyledTextArea
                name={name}
                placeholder={placeholder}
                handleChange={handleChange}
                handleBlur={handleBlur}
                value={value}
                description={description}
                error={error}
                errorIcon={errorIcon}
                minHeight={minHeight}
                minWidth={minWidth}
            />
        </Container>
    );
}

export default FormInput
